import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserState } from '../../states';
import { waitForUserLoaded } from './wait-for-user-loaded.util';

/**
 * Route guard that ensures the current user has been loaded and is known to
 * the application before allowing navigation. The OIDC sign-in is performed
 * once during app initialization (`provideAppInitializer` in each app's
 * `app.config.ts`), which dispatches `UserActions.LoadMe`. This guard simply
 * awaits the resulting `UserState.loaded` flag and then verifies that a user
 * was actually returned.
 */
export const canActivateUser: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    const store = inject(Store);
    const router = inject(Router);

    await waitForUserLoaded(store);

    return store.selectSnapshot(UserState.me) ? true : router.parseUrl('/');
};
